import { render, staticRenderFns } from "./CardTacaDasFavelas.vue?vue&type=template&id=3552ef86&scoped=true"
import script from "./CardTacaDasFavelas.vue?vue&type=script&lang=js"
export * from "./CardTacaDasFavelas.vue?vue&type=script&lang=js"
import style0 from "./CardTacaDasFavelas.vue?vue&type=style&index=0&id=3552ef86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552ef86",
  null
  
)

export default component.exports